import { render, staticRenderFns } from "./BackHeader.vue?vue&type=template&id=80914e3e&scoped=true&"
import script from "./BackHeader.vue?vue&type=script&lang=ts&"
export * from "./BackHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BackHeader.vue?vue&type=style&index=0&id=80914e3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80914e3e",
  null
  
)

export default component.exports